import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useTimer } from 'react-timer-hook';

import { useTimerLogic } from 'modules/Room/game-status/components/play-game-statuses/hooks/use-timer-logic';

import AnimatedTransition from 'shared/components/ui/AnimatedTransition/AnimatedTransition';
import {
  CountdownTimer,
  CountdownTimerType,
} from 'shared/components/ui/CountdownTimer/CountdownTimer';
import { InfoBannerType } from 'shared/components/ui/InfoBanner/InfoBanner';
import { MoveStatusRenderer } from 'shared/components/ui/MoveStatusRenderer/MoveStatusRenderer';
import { MoveStatusType } from 'shared/components/ui/MoveStatusRenderer/MoveStatusRenderer.types';
import { useRoomStore } from 'shared/store/roomStore';
import { epochToLocalUTC } from 'shared/utils/time';

export const WaitYourApproveMoveStatus = () => {
  const [showTimer, setShowTimer] = useState(false);
  const [showCloseButton, setShowCloseButton] = useState(false);
  const [technicalDefeatError, setTechnicalDefeatError] = useState(false);
  const { t } = useTranslation();
  const { closerRoom } = useRoomStore();

  const { onExpire } = useTimerLogic({
    gameStatusName: 'waitYourMove',
    setShowTimer,
    setShowCloseButton,
    setTechnicalDefeatError,
  });

  useTimer({
    expiryTimestamp: epochToLocalUTC(closerRoom?.deadline),
    onExpire: onExpire,
  });

  return (
    <>
      <AnimatedTransition show={!showTimer && !showCloseButton && !technicalDefeatError}>
        <MoveStatusRenderer
          statusIcon={MoveStatusType.WAITING_FOR_YOUR_MOVE}
          title={t('modals.approveYourMove.confirm')}
        />
      </AnimatedTransition>
      <AnimatedTransition show={showTimer}>
        <MoveStatusRenderer
          title={t('modals.approveYourMove.confirm')}
          type={InfoBannerType.WARNING}
        />
      </AnimatedTransition>
      <AnimatedTransition show={showCloseButton}>
        <MoveStatusRenderer title={t('modals.approveYourMove.technicalDefeatExplanation')} />
      </AnimatedTransition>
      <AnimatedTransition show={technicalDefeatError}>
        <MoveStatusRenderer
          title={t('modals.approveYourMove.technicalDefeatErrorExplanation')}
          type={InfoBannerType.WARNING}
        />
      </AnimatedTransition>
      {/* <AnimatedTransition show={showTimer && !showCloseButton}>
        <CountdownTimer
          expiryTimestamp={epochToLocalUTC(closerRoom?.deadline)}
          onComplete={onExpire}
          type={CountdownTimerType.WARNING}
          description={t('modals.approveYourMove.remember')}
        />
      </AnimatedTransition> */}
    </>
  );
};
